import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ConcurrentExperience, ExperiencePerformanceTypes, ExperienceTypes } from '@atlaskit/ufo';
export var ufoExperience = {
  mounted: 'component-mounted'
};
var ufoExperiences = _defineProperty({}, ufoExperience.mounted, new ConcurrentExperience(ufoExperience.mounted, {
  type: ExperienceTypes.Load,
  performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
  platform: {
    component: 'link-picker'
  }
}));
export var startUfoExperience = function startUfoExperience(experienceName, id, metadata) {
  var experience = ufoExperiences[experienceName].getInstance(id);
  experience.start();
  if (metadata) {
    experience.addMetadata(metadata);
  }
};
export var succeedUfoExperience = function succeedUfoExperience(experienceName, id, metadata) {
  var experience = ufoExperiences[experienceName].getInstance(id);
  experience.success({
    metadata: metadata
  });
};
export var failUfoExperience = function failUfoExperience(experienceName, id, metadata) {
  var experience = ufoExperiences[experienceName].getInstance(id);
  experience.failure({
    metadata: metadata
  });
};
export var abortUfoExperience = function abortUfoExperience(experienceName, id, metadata) {
  var experience = ufoExperiences[experienceName].getInstance(id);
  experience.abort({
    metadata: metadata
  });
};